module.exports = __webpack_public_path__ + "img/icon-taxi.73295060.svg";